var exports = {
  "tT": "DecoratedDownloadActionMenu__o8W5u1",
  "Mt": "MonaPixel__pmjSe0",
  "tZ": "ButtonOverlay__ZyCUNP",
  "yK": "ButtonOverlayText__38OYdn",
  "mg": "ButtonOverlayItem__cIrLDa",
};

module.exports = exports;
